import { makeAutoObservable } from 'mobx'
import { AccountRequest } from '../requests/AccountRequest'

class AccountStore {
  accountTruc = null

  /** Account list */
  accountList = []
  constructor() {
    makeAutoObservable(this)
  }
  updateAccountById = (accountId, accountInfo) => {
    return new Promise((resolve, reject) => {
      AccountRequest.updateAccountById(accountId, accountInfo)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          console.log(error)
          reject(error)
        })
    })
  }
  deleteAccountById = accountId => {
    return new Promise((resolve, reject) => {
      AccountRequest.deleteAccountById(accountId)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          console.log(error)
          reject(error)
        })
    })
  }
  createAccount = accountInfo => {
    return new Promise((resolve, reject) => {
      AccountRequest.createAccount(accountInfo)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          console.log(error)
          reject(error)
        })
    })
  }
  getCurrentUserAccount = () => {
    return new Promise((resolve, reject) => {
      AccountRequest.getCurrentUserAccount()
        .then(response => {
          this.accountList = response.data
          resolve(response)
        })
        .catch(error => {
          console.log(error)
          reject(error)
        })
    })
  }

  setActiveAccount = accountId => {
    return new Promise((resolve, reject) => {
      AccountRequest.switchAccount(accountId)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          console.log(error)
          reject(error)
        })
    })
  }

  /** Clear store */
  clearStore = () => {
    this.accountList.length = 0
    this.accountTruc = null
  }
}

const accountStore = new AccountStore()
export default accountStore
